import { AbacoVuexModule, State } from "@abaco/web-common/src/app";

export default class R2UDashboardVuexModule extends AbacoVuexModule {

    // @State() curElement!: Element | null;

}

